import { render } from "./ImageAlbum.vue?vue&type=template&id=5af11474"
import script from "./ImageAlbum.vue?vue&type=script&lang=js"
export * from "./ImageAlbum.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__